module.exports = __webpack_public_path__ + "img/ZB53详情页_06.1f9b0c2b.jpg";